'use client';

// Replaces the root layout when it fails, so it can't rely on the app's
// stylesheet or DB theme -- colours are the default theme's, inlined.
export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  return (
    <html lang="en">
      <body
        style={{
          margin: 0,
          minHeight: '100vh',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          padding: '24px',
          background: '#FAF7F2',
          color: '#1E1A17',
          fontFamily: "-apple-system, 'Helvetica Neue', Arial, sans-serif",
        }}
      >
        <title>Something went wrong — Canvas Staging</title>
        <div style={{ maxWidth: 420, textAlign: 'center' }}>
          <h1 style={{ fontSize: 24, margin: '0 0 8px' }}>Something went wrong</h1>
          <p style={{ color: '#6B5F54', margin: '0 0 24px', lineHeight: 1.5 }}>
            We hit an unexpected problem loading this page. Please try again in a moment.
          </p>
          <button
            onClick={() => retry()}
            style={{
              background: '#80623D',
              color: '#FFFFFF',
              border: 0,
              borderRadius: 8,
              padding: '12px 24px',
              fontSize: 14,
              fontWeight: 600,
              cursor: 'pointer',
            }}
          >
            Try again
          </button>
          {error.digest && (
            <p style={{ color: '#8C7B6B', fontSize: 12, marginTop: 24 }}>
              Reference: {error.digest}
            </p>
          )}
        </div>
      </body>
    </html>
  );
}
